import { render, staticRenderFns } from "./RecommendationsPage.vue?vue&type=template&id=0ebc4473&"
import script from "./RecommendationsPage.vue?vue&type=script&lang=js&"
export * from "./RecommendationsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports